import React, { useState } from "react";
import jsPDF from "jspdf";
import axios from "axios";
import logoPng from "../../assets/logo.png";

// Mapeamento dos nomes das colunas (igual ao ScoutAthletes.jsx)
const columnLabels = {
  Points: "Pontos",
  Serves: "Saque",
  Attacks: "Ataque",
  Reception: "Recepção",
  Blocks: "BK",
  Total: "Tot",
  PB: "PB",
  WL: "WL",
  PointsPercent: "Pts%",
  Points: "Pts",
  Errors: "Err",
  Blocks: "BK",
  PosPercent: "Pos%",
  ExcPercent: "Exc%",
};

const groupOrder = ["Points", "Serves", "Attacks", "Reception", "Blocks"];
const subgroupOrder = {
  Points: ["Total", "PB", "WL"],
  Serves: ["Total", "Points", "Errors"],
  Attacks: ["Total", "Points", "Blocks", "Errors", "PointsPercent"],
  Reception: ["Total", "Errors", "PosPercent", "ExcPercent"],
  Blocks: [], // valor simples
};

const ExportPDFButton = ({
  partida,
  teamNames,
  teams,
  selectedSet,
  ultimoSet,
  homeNumbers,
  awayNumbers,
  currentTab = "set",
  data,
  hora,
  campeonato,
  temporada,
  local,
  placarGeral,
  placarSets,
}) => {
  const [isExporting, setIsExporting] = useState(false);

  // Mapeamento dos nomes das colunas (igual ao ScoutAthletes.jsx)
  const columnLabels = {
    Points: "Pontos",
    Serves: "Saque",
    Attacks: "Ataque",
    Reception: "Recepção",
    Blocks: "BK",
    Total: "Tot",
    PB: "PB",
    WL: "WL",
    PointsPercent: "Pts%",
    Points: "Pts",
    Errors: "Err",
    Blocks: "BK",
    PosPercent: "Pos%",
    ExcPercent: "Exc%",
  };

  const groupOrder = ["Points", "Serves", "Attacks", "Reception", "Blocks"];
  const subgroupOrder = {
    Points: ["Total", "PB", "WL"],
    Serves: ["Total", "Points", "Errors"],
    Attacks: ["Total", "Points", "Blocks", "Errors", "PointsPercent"],
    Reception: ["Total", "Errors", "PosPercent", "ExcPercent"],
    Blocks: [], // valor simples
  };

  // Função para buscar dados de todos os sets
  const fetchAllSetsData = async () => {
    try {
      const allSetsData = {};

      // Buscar dados de cada set
      for (let setNum = 1; setNum <= ultimoSet; setNum++) {
        if (!teams?.home || !teams?.away) continue;

        // Monta arrays de atletas para cada time (igual ao ScoutAthletes.jsx)
        const homeAthletesPayload = teams.home.map((ath) => ({
          number: ath.number,
          time: "*",
        }));
        const awayAthletesPayload = teams.away.map((ath) => ({
          number: ath.number,
          time: "a",
        }));

        // Chama o endpoint para cada time SEPARADAMENTE (igual ao ScoutAthletes.jsx)
        const [homeRes, awayRes] = await Promise.all([
          homeAthletesPayload.length > 0
            ? axios.post(
                `${
                  import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                }/reports/athletes-report-set-multi`,
                {
                  set: setNum,
                  partida,
                  athletes: homeAthletesPayload,
                }
              )
            : Promise.resolve({ data: {} }),
          awayAthletesPayload.length > 0
            ? axios.post(
                `${
                  import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
                }/reports/athletes-report-set-multi`,
                {
                  set: setNum,
                  partida,
                  athletes: awayAthletesPayload,
                }
              )
            : Promise.resolve({ data: {} }),
        ]);

        allSetsData[setNum] = {
          home: homeRes.data || {},
          away: awayRes.data || {},
        };
      }

      return allSetsData;
    } catch (error) {
      console.error("Erro ao buscar dados de todos os sets:", error);
      return {};
    }
  };

  // Função para buscar dados gerais
  const fetchGeneralData = async () => {
    try {
      if (!teams?.home || !teams?.away) {
        return { home: {}, away: {} };
      }

      // Monta arrays de atletas para cada time (igual ao ScoutAthletes.jsx)
      const homeAthletesPayload = teams.home.map((ath) => ({
        number: ath.number,
        time: "*",
      }));
      const awayAthletesPayload = teams.away.map((ath) => ({
        number: ath.number,
        time: "a",
      }));

      // Chama o endpoint para cada time SEPARADAMENTE (igual ao ScoutAthletes.jsx)
      const [homeRes, awayRes] = await Promise.all([
        homeAthletesPayload.length > 0
          ? axios.post(
              `${
                import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
              }/reports/athletes-report-set-multi`,
              {
                set: null, // sem set específico = geral
                partida,
                athletes: homeAthletesPayload,
              }
            )
          : Promise.resolve({ data: {} }),
        awayAthletesPayload.length > 0
          ? axios.post(
              `${
                import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
              }/reports/athletes-report-set-multi`,
              {
                set: null, // sem set específico = geral
                partida,
                athletes: awayAthletesPayload,
              }
            )
          : Promise.resolve({ data: {} }),
      ]);

      return {
        home: homeRes.data || {},
        away: awayRes.data || {},
      };
    } catch (error) {
      console.error("Erro ao buscar dados gerais:", error);
      return { home: {}, away: {} };
    }
  };

  // Função para buscar dados de fundamentos
  const fetchFundamentalsData = async () => {
    try {
      const homeResponse = await axios.post(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/reports/athletes-fundamentals`,
        { partida, team: "home" }
      );

      const awayResponse = await axios.post(
        `${
          import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
        }/reports/athletes-fundamentals`,
        { partida, team: "away" }
      );

      return {
        home: homeResponse.data,
        away: awayResponse.data,
      };
    } catch (error) {
      console.error("Erro ao buscar dados de fundamentos:", error);
      return { home: { athletes: [] }, away: { athletes: [] } };
    }
  };

  // Função para formatar valores (igual ao ScoutAthletes.jsx)
  const formatValue = (val) => {
    if (
      val === 0 ||
      val === null ||
      val === undefined ||
      val === "" ||
      val === "0"
    ) {
      return "-";
    }
    return val;
  };

  // Função para criar linha de totais para fundamentos
  const createFundamentalsTotalsRow = (
    athletes,
    fundamentosKeys,
    qualidades
  ) => {
    const totals = {};
    fundamentosKeys.forEach((f) => {
      totals[f] = {};
      qualidades.forEach((q) => {
        totals[f][q] = athletes.reduce((sum, ath) => {
          const val = ath[f]?.[q];
          return sum + (val !== "-" ? Number(val) : 0);
        }, 0);
      });
    });
    return totals;
  };

  // Função para criar linha de totais para relatório geral/sets
  const createDetailedTotalsRow = (athletes, dataObj) => {
    // Estrutura igual ao groupOrder/subgroupOrders
    const totais = {};
    groupOrder.forEach((group) => {
      totais[group] = {};
      if (subgroupOrder[group].length > 0) {
        subgroupOrder[group].forEach((sub) => {
          totais[group][sub] = 0;
        });
      } else {
        totais[group] = 0;
      }
    });
    athletes.forEach((ath) => {
      const num = ath.number;
      const dados = dataObj[num] || {};
      // Points
      if (dados.Points) {
        if (dados.Points.Total)
          totais.Points.Total += Number(dados.Points.Total) || 0;
        if (dados.Points.PB) totais.Points.PB += Number(dados.Points.PB) || 0;
        // WL: hífen
      }
      // Serves
      if (dados.Serves) {
        if (dados.Serves.Total)
          totais.Serves.Total += Number(dados.Serves.Total) || 0;
        if (dados.Serves.Points)
          totais.Serves.Points += Number(dados.Serves.Points) || 0;
        if (dados.Serves.Errors)
          totais.Serves.Errors += Number(dados.Serves.Errors) || 0;
      }
      // Attacks
      if (dados.Attacks) {
        if (dados.Attacks.Total)
          totais.Attacks.Total += Number(dados.Attacks.Total) || 0;
        if (dados.Attacks.Points)
          totais.Attacks.Points += Number(dados.Attacks.Points) || 0;
        if (dados.Attacks.Blocks)
          totais.Attacks.Blocks += Number(dados.Attacks.Blocks) || 0;
        if (dados.Attacks.Errors)
          totais.Attacks.Errors += Number(dados.Attacks.Errors) || 0;
        // PointsPercent: hífen
      }
      // Reception
      if (dados.Reception) {
        if (dados.Reception.Total)
          totais.Reception.Total += Number(dados.Reception.Total) || 0;
        if (dados.Reception.Errors)
          totais.Reception.Errors += Number(dados.Reception.Errors) || 0;
        // PosPercent, ExcPercent: hífen
      }
      // Blocks
      if (dados.Blocks !== undefined) {
        totais.Blocks += Number(dados.Blocks) || 0;
      }
    });
    // Pós-processamento para hífens
    totais.Points.WL = "-";
    totais.Attacks.PointsPercent = "-";
    totais.Reception.PosPercent = "-";
    totais.Reception.ExcPercent = "-";
    return totais;
  };

  // Função utilitária para cor de fundo zebrada (agora com xBase e largura correta)
  const fillZebra = (pdf, y, width, isEven, x = 0) => {
    if (isEven) {
      pdf.setFillColor(242, 242, 242); // #f2f2f2
      pdf.rect(x, y - 4, width, 6, "F");
    }
  };

  // Função para criar tabela detalhada igual à da tela (com linha de totais)
  const createDetailedTable = (
    pdf,
    dataObj,
    athletes,
    teamName,
    startY,
    margin,
    pageHeight
  ) => {
    let currentY = startY;
    const rowHeight = 6;
    const colWidth = 12;
    // Calcular largura total da tabela: # + Nome + (Nome final) + todas as colunas
    let totalCols = 3; // #, Nome, Nome final
    groupOrder.forEach((group) => {
      if (subgroupOrder[group].length > 0) {
        totalCols += subgroupOrder[group].length;
      } else {
        totalCols += 1;
      }
    });
    const tableWidth = colWidth * totalCols;
    const sortedAthletes = [...athletes]
      .filter(
        (a) => a.number !== "" && a.number !== null && a.number !== undefined
      )
      .sort((a, b) => Number(a.number) - Number(b.number));
    pdf.setFontSize(8);
    pdf.setFont("helvetica", "bold");
    pdf.text(teamName, margin, currentY);
    currentY += 8;
    pdf.setFontSize(8);
    pdf.setFont("helvetica", "bold");
    let xPos = margin;
    pdf.text("#", xPos, currentY);
    xPos += colWidth;
    pdf.text("Nome", xPos, currentY);
    xPos += colWidth * 2;
    groupOrder.forEach((group, idx) => {
      if (subgroupOrder[group].length > 0) {
        const groupWidth = colWidth * subgroupOrder[group].length;
        pdf.text(columnLabels[group] || group, xPos, currentY);
        xPos += groupWidth;
      } else {
        pdf.text(columnLabels[group] || group, xPos, currentY);
        xPos += colWidth;
      }
    });
    pdf.text("Nome", xPos, currentY);
    currentY += rowHeight;
    // Subcabeçalho (shift para direita)
    xPos = margin + colWidth * 3;
    groupOrder.forEach((group) => {
      if (subgroupOrder[group].length > 0) {
        subgroupOrder[group].forEach((sub) => {
          pdf.text(columnLabels[sub] || sub, xPos, currentY);
          xPos += colWidth;
        });
      } else {
        xPos += colWidth;
      }
    });
    currentY += rowHeight;
    pdf.setFontSize(7);
    pdf.setFont("helvetica", "normal");
    sortedAthletes.forEach((ath, idx) => {
      if (currentY + rowHeight > pageHeight - margin) {
        pdf.addPage();
        currentY = 20;
      }
      fillZebra(pdf, currentY, tableWidth, idx % 2 === 0, margin);
      const dados = dataObj[ath.number] || {};
      xPos = margin;
      pdf.text(String(ath.number), xPos, currentY);
      xPos += colWidth;
      pdf.text(String(ath.name || `Atleta ${ath.number}`), xPos, currentY);
      xPos += colWidth * 2;
      groupOrder.forEach((group) => {
        if (subgroupOrder[group].length > 0) {
          subgroupOrder[group].forEach((sub) => {
            let value = dados[group]?.[sub];
            if (group === "Points" && sub === "WL") value = "-";
            if (group === "Attacks" && sub === "PointsPercent") value = "-";
            if (
              group === "Reception" &&
              (sub === "PosPercent" || sub === "ExcPercent")
            )
              value = "-";
            value = formatValue(value);
            pdf.text(String(value), xPos, currentY);
            xPos += colWidth;
          });
        } else {
          const value = formatValue(dados[group]);
          pdf.text(String(value), xPos, currentY);
          xPos += colWidth;
        }
      });
      pdf.text(String(ath.name || `Atleta ${ath.number}`), xPos, currentY);
      currentY += rowHeight;
    });
    // Linha de totais (não zebrada)
    const totais = createDetailedTotalsRow(sortedAthletes, dataObj);
    xPos = margin;
    pdf.setFont("helvetica", "bold");
    pdf.text("Σ", xPos, currentY);
    xPos += colWidth;
    pdf.text("Total", xPos, currentY);
    xPos += colWidth * 2;
    groupOrder.forEach((group) => {
      if (subgroupOrder[group].length > 0) {
        subgroupOrder[group].forEach((sub) => {
          let value = totais[group][sub];
          value = formatValue(value);
          pdf.text(String(value), xPos, currentY);
          xPos += colWidth;
        });
      } else {
        let value = totais[group];
        value = formatValue(value);
        pdf.text(String(value), xPos, currentY);
        xPos += colWidth;
      }
    });
    pdf.text("", xPos, currentY);
    pdf.setFont("helvetica", "normal");
    currentY += rowHeight;
    return currentY - startY;
  };

  // Função para desenhar o logo SVG no PDF
  const drawLogo = (pdf) => {
    const logoUrl = `${window.location.origin}/logo.png`;

    pdf.addImage(
      logoPng,
      "PNG",
      pdf.internal.pageSize.getWidth() - 30,
      10,
      15,
      15
    );
  };

  // Função para cabeçalho invertido
  const addPageHeader = (
    pdf,
    partidaTitle,
    subTitle,
    homeTeam,
    awayTeam,
    setNum = null,
    margin = 15,
    yOffset = 20
  ) => {
    drawLogo(pdf);
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    let partidaHeader = `${homeTeam} vs ${awayTeam}`;
    pdf.text(partidaHeader, margin, yOffset);
    yOffset += 6;
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");
    // Dados adicionais
    if (data || hora || campeonato || temporada) {
      let info = [];
      if (data) info.push(`Data: ${data}`);
      if (hora) info.push(`Hora: ${hora}`);
      if (campeonato) info.push(`Campeonato: ${campeonato}`);
      if (temporada) info.push(`Temporada: ${temporada}`);
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");
      pdf.text(info.join("   |   "), margin, yOffset);
      yOffset += 6;
    }
    let subheader = subTitle;
    if (setNum !== null) subheader += ` ${setNum}`;
    pdf.text(subheader, margin, yOffset);
    yOffset += 12;
    return yOffset;
  };

  // Função para adicionar número de página no rodapé
  const addPageNumbers = (pdf) => {
    const pageCount = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      pdf.setFontSize(8);
      pdf.setFont("helvetica", "normal");
      pdf.text(
        `${i} / ${pageCount}`,
        pdf.internal.pageSize.getWidth() - 20,
        pdf.internal.pageSize.getHeight() - 8,
        { align: "right" }
      );
    }
  };

  // Função para criar tabela de fundamentos lado a lado (6 por página: 2x3)
  const createFundamentalsQuadTable = (
    pdf,
    athletes,
    teamName,
    fundamentosKeys,
    startY,
    margin,
    pageHeight
  ) => {
    let currentY = startY;
    const rowHeight = 4; // Altura reduzida das linhas
    const colWidth = 8; // Colunas mais estreitas
    const tableSpacing = 8; // Espaçamento reduzido entre tabelas
    const qualidades = ["#", "+", "!", "-", "/", "="];
    const colCount = 1 + 2 + qualidades.length + 1; // Nº + Nome(2) + qualidades + Tot
    const singleTableWidth = colWidth * colCount;
    const fundamentosLabels = {
      S: "Saque",
      R: "Recepção",
      E: "Levantamento",
      A: "Ataque",
      B: "Bloqueio",
      D: "Defesa",
    };
    const sortedAthletes = [...athletes]
      .filter(
        (a) => a.number !== "" && a.number !== null && a.number !== undefined
      )
      .sort((a, b) => Number(a.number) - Number(b.number));

    // Adicionar nome do time
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "bold");
    pdf.text(teamName, margin, startY);
    startY += 6; // Margem ainda menor entre nome do time e tabela

    // Calcular posições das 6 tabelas (2x3)
    const pageWidth = pdf.internal.pageSize.getWidth();
    const availableWidth = pageWidth - 2 * margin;
    const tableAreaWidth = availableWidth / 2;
    const tableAreaHeight = (pageHeight - startY - margin) / 3; // Dividido por 3 para 3 linhas

    const positions = [
      // 2 tabelas na primeira linha
      { x: margin, y: startY },
      { x: margin + tableAreaWidth + tableSpacing, y: startY },
      // 2 tabelas na segunda linha
      { x: margin, y: startY + tableAreaHeight + 3 },
      {
        x: margin + tableAreaWidth + tableSpacing,
        y: startY + tableAreaHeight + 3,
      },
      // 2 tabelas na terceira linha
      { x: margin, y: startY + (tableAreaHeight + 3) * 2 },
      {
        x: margin + tableAreaWidth + tableSpacing,
        y: startY + (tableAreaHeight + 3) * 2,
      },
    ];

    // Desenhar as 6 tabelas
    fundamentosKeys.forEach((f, idx) => {
      if (idx >= 6) return; // Máximo 6 tabelas por página

      const pos = positions[idx];
      let xBase = pos.x;
      let yBase = pos.y;
      const tableHeight = tableAreaHeight - 2; // altura máxima da tabela (aprox)
      // Título do fundamento
      pdf.setFontSize(9);
      pdf.setFont("helvetica", "bold");
      pdf.text(fundamentosLabels[f], xBase, yBase);
      yBase += 6;

      // Salvar início do cabeçalho das colunas para a borda externa
      const tableYStart = yBase;

      // Cabeçalho da tabela
      pdf.setFontSize(5);
      pdf.setFont("helvetica", "bold");
      let xPos = xBase;
      pdf.text("Nº", xPos, yBase);
      xPos += colWidth;
      pdf.text("Nome", xPos, yBase);
      xPos += colWidth * 2; // Nome com largura dupla
      qualidades.forEach((q) => {
        pdf.text(q, xPos, yBase);
        xPos += colWidth;
      });
      pdf.text("Tot", xPos, yBase);
      yBase += rowHeight;

      // Dados dos atletas
      pdf.setFontSize(5);
      pdf.setFont("helvetica", "normal");
      let firstDataY = yBase;
      let lastDataY = yBase;
      sortedAthletes.forEach((ath, athIdx) => {
        if (yBase > pos.y + tableAreaHeight - rowHeight * 2) return; // Evitar overflow

        let xPos = xBase;
        // Zebra alinhado: só nas linhas de dados
        if (athIdx % 2 === 0) {
          pdf.setFillColor(242, 242, 242);
          pdf.rect(xBase, yBase - 2, singleTableWidth, rowHeight + 3, "F");
        }

        pdf.text(String(ath.number), xPos, yBase);
        xPos += colWidth;
        pdf.text(String(ath.name || `Atleta ${ath.number}`), xPos, yBase);
        xPos += colWidth * 2; // Nome com largura dupla
        qualidades.forEach((q) => {
          const value = ath[f]?.[q] || "-";
          pdf.text(String(value), xPos, yBase);
          xPos += colWidth;
        });
        const getRowTotal = (ath, f) =>
          qualidades.reduce((sum, q) => {
            const val = ath[f]?.[q];
            return sum + (val !== "-" ? Number(val) : 0);
          }, 0);
        pdf.setFont("helvetica", "bold");
        pdf.text(String(getRowTotal(ath, f)), xPos, yBase);
        pdf.setFont("helvetica", "normal");
        lastDataY = yBase;
        yBase += rowHeight;
      });

      // Linha de totais
      const totals = createFundamentalsTotalsRow(
        sortedAthletes,
        [f],
        qualidades
      );
      let xPosTot = xBase;
      pdf.setFont("helvetica", "bold");
      pdf.setFillColor(255, 255, 200);
      pdf.rect(xBase, yBase, singleTableWidth, rowHeight, "F");
      pdf.text("Σ", xPosTot, yBase);
      xPosTot += colWidth;
      pdf.text("Total", xPosTot, yBase);
      xPosTot += colWidth * 2;
      qualidades.forEach((q) => {
        pdf.text(String(totals[f][q]), xPosTot, yBase);
        xPosTot += colWidth;
      });
      const totalRow = Object.values(totals[f]).reduce(
        (sum, v) => sum + (v !== "-" ? Number(v) : 0),
        0
      );
      pdf.text(String(totalRow), xPosTot, yBase);
      pdf.setFont("helvetica", "normal");
      // Bordas externas da tabela (englobando cabeçalho, dados e totais)
      const tableYEnd = yBase + rowHeight;
      pdf.setDrawColor(80);
      pdf.setLineWidth(0.4);
      pdf.rect(xBase, tableYStart, singleTableWidth, tableYEnd - tableYStart);
    });

    return pageHeight - startY; // Retorna altura total da página
  };

  // Nova função para desenhar tabela com subcolunas
  const drawDetailedTable = (
    pdf,
    dataObj,
    athletes,
    teamName,
    yStart,
    zebraStart,
    margin,
    pageHeight
  ) => {
    const rowHeight = 6;
    // Definição das colunas e subcolunas (estreitas)
    const columns = [
      { key: "number", label: "#", width: 8, sub: [] }, // 1
      { key: "name", label: "Nome", width: 30, sub: [] }, // 2
      {
        key: "Points",
        label: "Pontos",
        width: 24,
        sub: [
          { key: "Total", label: "Tot" }, // 3
          { key: "PB", label: "PB" }, // 4
          { key: "WL", label: "WL" }, // 5
        ],
      },
      {
        key: "Serves",
        label: "Saque",
        width: 24,
        sub: [
          { key: "Total", label: "Tot" }, // 6
          { key: "Points", label: "Pts" }, // 7
          { key: "Errors", label: "Err" }, // 8
        ],
      },
      {
        key: "Attacks",
        label: "Ataque",
        width: 40,
        sub: [
          { key: "Total", label: "Tot" }, // 9
          { key: "Points", label: "Pts" }, // 10
          { key: "Blocks", label: "Blo" }, // 11
          { key: "Errors", label: "Err" }, // 12
          { key: "PointsPercent", label: "%" }, // 13
        ],
      },
      {
        key: "Reception",
        label: "Recepção",
        width: 32,
        sub: [
          { key: "Total", label: "Tot" }, // 14
          { key: "Errors", label: "Err" }, // 15
          { key: "PosPercent", label: "%" }, // 16
          { key: "ExcPercent", label: "Exc%" }, // 17
        ],
      },
      { key: "Blocks", label: "BK", width: 8, sub: [] }, // 18
    ];
    // Calcular larguras das subcolunas
    const subColWidth = 8;
    const colWidths = columns.map((col) =>
      col.sub.length > 0 ? col.sub.length * subColWidth : col.width
    );
    const totalWidth = colWidths.reduce((a, b) => a + b, 0);
    // Calcular as posições X de cada coluna
    let colX = [margin];
    let x = margin;
    columns.forEach((col) => {
      if (col.sub.length > 0) {
        for (let i = 0; i < col.sub.length; i++) {
          x += subColWidth;
          colX.push(x);
        }
      } else {
        x += col.width;
        colX.push(x);
      }
    });
    // Índices das colunas para borda: 2, 5, 8, 13, 17 (1-based)
    const borderColIndices = [2, 5, 8, 13, 17];
    let y = yStart;
    const yTableStart = y; // início da tabela (antes do cabeçalho)
    pdf.setFontSize(10);
    pdf.setFont("helvetica", "bold");
    pdf.text(teamName, margin, y);
    // NÃO incremente y aqui!
    // Cabeçalho 1: Fundamentos
    let xHeader = margin;
    columns.forEach((col, i) => {
      if (col.sub.length > 0) {
        pdf.setFontSize(8);
        pdf.text(
          col.label,
          xHeader + (col.sub.length * subColWidth) / 2,
          y + rowHeight,
          { align: "center" }
        );
        xHeader += col.sub.length * subColWidth;
      } else {
        pdf.setFontSize(8);
        pdf.text(col.label, xHeader + col.width / 2, y + rowHeight, {
          align: "center",
        });
        xHeader += col.width;
      }
    });
    // Bordas verticais à esquerda de # e à direita de BK
    pdf.setDrawColor(80);
    pdf.setLineWidth(0.4);
    pdf.line(margin, y, margin, y + rowHeight * 2 + 1);
    pdf.line(
      margin + totalWidth,
      y,
      margin + totalWidth,
      y + rowHeight * 2 + 1
    );
    // Bordas verticais solicitadas (2,5,8,13,17)
    pdf.setDrawColor(60);
    pdf.setLineWidth(0.2);
    borderColIndices.forEach((idx) => {
      if (colX[idx] !== undefined) {
        pdf.line(colX[idx], y, colX[idx], y + rowHeight * 2 + 1);
      }
    });
    // Cabeçalho 2: Subcolunas
    x = margin;
    columns.forEach((col) => {
      if (col.sub.length > 0) {
        col.sub.forEach((sub) => {
          pdf.setFontSize(7);
          pdf.text(sub.label, x + subColWidth / 2, y + rowHeight * 2, {
            align: "center",
          });
          x += subColWidth;
        });
      } else {
        pdf.setFontSize(7);
        pdf.text("", x + col.width / 2, y + rowHeight * 2, { align: "center" });
        x += col.width;
      }
    });
    // Linha horizontal acima do cabeçalho principal
    pdf.setDrawColor(80);
    pdf.setLineWidth(0.4);
    pdf.line(margin, y, margin + totalWidth, y);
    // Linha horizontal abaixo do cabeçalho de subcolunas
    pdf.setDrawColor(80);
    pdf.setLineWidth(0.4);
    pdf.line(
      margin,
      y + rowHeight * 2 + 1,
      margin + totalWidth,
      y + rowHeight * 2 + 1
    );
    // Bordas verticais especiais (Nome, WL, Err, Tot)
    let xBorders = [];
    let xPos = margin;
    columns.forEach((col) => {
      if (col.key === "name" || col.key === "Blocks") {
        xBorders.push(xPos + col.width); // após Nome, após BK
      }
      if (col.sub.length > 0) {
        col.sub.forEach((sub, idx) => {
          // Adicionar linha vertical após Err (de Saque, Ataque, Recepção)
          if (
            (col.key === "Serves" && sub.key === "Err") ||
            (col.key === "Attacks" && sub.key === "Err") ||
            (col.key === "Reception" && sub.key === "Err")
          ) {
            xBorders.push(xPos + subColWidth * (idx + 1));
          }
          // Remover linha entre % e Exc% (NÃO adicionar)
          // Não adicionar linha entre % e Exc%
        });
        xPos += col.sub.length * subColWidth;
      } else {
        xPos += col.width;
      }
    });
    xBorders.push(margin + totalWidth); // borda final
    // Bordas verticais nos cabeçalhos
    xBorders.forEach((xB) => {
      pdf.setDrawColor(180);
      pdf.setLineWidth(0.3);
      pdf.line(xB, y, xB, y + rowHeight * 2 + 1);
    });
    let dataY = y + rowHeight * 2 + 1;
    pdf.setFont("helvetica", "normal");
    const sortedAthletes = [...athletes]
      .filter(
        (a) => a.number !== "" && a.number !== null && a.number !== undefined
      )
      .sort((a, b) => Number(a.number) - Number(b.number));
    // Linhas de dados
    sortedAthletes.forEach((ath, idx) => {
      if (dataY > pageHeight - margin - rowHeight * 2) {
        pdf.addPage();
        dataY = margin + rowHeight * 2 + 1;
      }
      // Zebra: alinhar exatamente com a linha de dados
      if ((idx + zebraStart) % 2 === 0) {
        pdf.setFillColor(242, 242, 242);
        pdf.rect(margin, dataY, totalWidth, rowHeight, "F");
      }
      let x = margin;
      columns.forEach((col, i) => {
        if (col.key === "number") {
          pdf.setFontSize(8);
          pdf.text(
            String(ath.number),
            x + col.width / 2,
            dataY + rowHeight / 1.7,
            { align: "center" }
          );
          x += col.width;
        } else if (col.key === "name") {
          pdf.setFontSize(8);
          pdf.text(
            String(ath.name || `Atleta ${ath.number}`),
            x + 2,
            dataY + rowHeight / 1.7,
            { align: "left" }
          );
          x += col.width;
        } else if (col.sub.length > 0) {
          col.sub.forEach((sub) => {
            let value = formatValue(dataObj[ath.number]?.[col.key]?.[sub.key]);
            pdf.setFontSize(8);
            pdf.text(
              String(value),
              x + subColWidth - 2,
              dataY + rowHeight / 1.7,
              { align: "right" }
            );
            x += subColWidth;
          });
        } else if (col.key === "Blocks") {
          let value = formatValue(dataObj[ath.number]?.Blocks);
          pdf.setFontSize(8);
          pdf.text(String(value), x + col.width - 2, dataY + rowHeight / 1.7, {
            align: "right",
          });
          x += col.width;
        }
      });
      // Linha horizontal após cada linha de dados
      pdf.setDrawColor(230);
      pdf.setLineWidth(0.1);
      pdf.line(
        margin,
        dataY + rowHeight,
        margin + totalWidth,
        dataY + rowHeight
      );
      // Bordas verticais solicitadas (2,5,8,13,17)
      pdf.setDrawColor(60);
      pdf.setLineWidth(0.2);
      borderColIndices.forEach((idx) => {
        if (colX[idx] !== undefined) {
          pdf.line(colX[idx], dataY, colX[idx], dataY + rowHeight);
        }
      });
      dataY += rowHeight;
    });
    // Linha de totais
    const totais = createDetailedTotalsRow(sortedAthletes, dataObj);
    pdf.setFont("helvetica", "bold");
    pdf.setFillColor(255, 255, 200);
    pdf.rect(margin, dataY, totalWidth, rowHeight, "F");
    let xTot = margin;
    columns.forEach((col, i) => {
      if (col.key === "number") {
        pdf.text("Σ", xTot + col.width / 2, dataY + rowHeight / 1.7, {
          align: "center",
        });
        xTot += col.width;
      } else if (col.key === "name") {
        pdf.text("Total", xTot + 2, dataY + rowHeight / 1.7, { align: "left" });
        xTot += col.width;
      } else if (col.sub.length > 0) {
        col.sub.forEach((sub) => {
          let value =
            totais[col.key]?.[sub.key] !== undefined
              ? totais[col.key][sub.key]
              : "-";
          pdf.text(
            String(value),
            xTot + subColWidth - 2,
            dataY + rowHeight / 1.7,
            { align: "right" }
          );
          xTot += subColWidth;
        });
      } else if (col.key === "Blocks") {
        let value = totais.Blocks !== undefined ? totais.Blocks : "-";
        pdf.text(String(value), xTot + col.width - 2, dataY + rowHeight / 1.7, {
          align: "right",
        });
        xTot += col.width;
      }
    });
    // Linha horizontal após totais
    pdf.setDrawColor(80);
    pdf.setLineWidth(0.4);
    pdf.line(margin, dataY + rowHeight, margin + totalWidth, dataY + rowHeight);
    // Bordas verticais solicitadas (2,5,8,13,17) na linha de totais
    pdf.setDrawColor(60);
    pdf.setLineWidth(0.2);
    borderColIndices.forEach((idx) => {
      if (colX[idx] !== undefined) {
        pdf.line(colX[idx], dataY, colX[idx], dataY + rowHeight);
      }
    });
    // Após desenhar totais, calcule o y final da tabela
    const yTableEnd = dataY + rowHeight;
    // Borda externa da tabela (corrigida)
    pdf.setDrawColor(80);
    pdf.setLineWidth(0.4);
    pdf.rect(margin, yTableStart, totalWidth, yTableEnd - yTableStart);
    return yTableEnd;
  };

  // Trocar orientação para portrait
  const exportToPDF = async () => {
    setIsExporting(true);
    try {
      const pdf = new jsPDF("p", "mm", "a4"); // portrait
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      let yOffset = margin;
      const homeTeam =
        typeof teamNames?.home === "string"
          ? teamNames.home
          : teamNames?.home?.name || "Home";
      const awayTeam =
        typeof teamNames?.away === "string"
          ? teamNames.away
          : teamNames?.away?.name || "Away";

      // --- 1. PÁGINA GERAL (RESULTADO DO JOGO) ---
      // Cabeçalho
      pdf.setFontSize(13);
      pdf.setFont("helvetica", "bold");
      pdf.text("Relatório de Jogo", pageWidth / 2, yOffset, {
        align: "center",
      });
      yOffset += 7;
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");
      pdf.text(
        `${homeTeam} vs ${awayTeam}    |    Data: ${
          data || "-"
        }    |    Local: ${local || "-"}`,
        pageWidth / 2,
        yOffset,
        { align: "center" }
      );
      yOffset += 6;
      pdf.text(
        `Placar: ${placarGeral || "-"}    |    Campeonato: ${
          campeonato || "-"
        }    |    Temporada: ${temporada || "-"}`,
        pageWidth / 2,
        yOffset,
        { align: "center" }
      );
      yOffset += 8;
      // Placar dos sets
      if (placarSets) {
        pdf.setFontSize(9);
        pdf.text(`Sets: ${placarSets}`, pageWidth / 2, yOffset, {
          align: "center",
        });
        yOffset += 6;
      }
      yOffset += 2;
      // --- Tabelas Home e Away ---
      const generalData = await fetchGeneralData();
      // Adicionar logo no topo da página geral
      drawLogo(pdf);
      // Home em cima
      pdf.setFontSize(12);
      pdf.setFont("helvetica", "bold");
      pdf.text(homeTeam, margin, yOffset);
      yOffset += 10; // respiro entre nome e tabela

      let yTableEnd = drawDetailedTable(
        pdf,
        generalData.home,
        teams.home,
        "", // não desenha nome do time dentro da tabela
        yOffset,
        0,
        margin,
        pageHeight
      );
      yOffset = yTableEnd + 10; // espaço extra entre tabelas
      // Away embaixo
      pdf.setFontSize(12);
      pdf.setFont("helvetica", "bold");
      pdf.text(awayTeam, margin, yOffset);
      yOffset += 10; // respiro entre nome e tabela
      yTableEnd = drawDetailedTable(
        pdf,
        generalData.away,
        teams.away,
        "", // não desenha nome do time dentro da tabela
        yOffset,
        teams.home?.length || 0,
        margin,
        pageHeight
      );
      yOffset = yTableEnd + 8;
      // 2. RELATÓRIOS DE CADA SET
      const allSetsData = await fetchAllSetsData();
      for (let setNum = 1; setNum <= ultimoSet; setNum++) {
        pdf.addPage();
        yOffset = addPageHeader(
          pdf,
          "Partida",
          "Set",
          homeTeam,
          awayTeam,
          setNum,
          margin,
          20
        );
        // Home em cima
        if (allSetsData[setNum]?.home && teams?.home) {
          pdf.setFontSize(12);
          pdf.setFont("helvetica", "bold");
          pdf.text(homeTeam, margin, yOffset);
          yOffset += 10; // respiro
          let yTableEnd = drawDetailedTable(
            pdf,
            allSetsData[setNum].home,
            teams.home,
            "", // não desenha nome do time dentro da tabela
            yOffset,
            0,
            margin,
            pageHeight
          );
          yOffset = yTableEnd + 10;
        }
        yOffset += 10; // espaço extra entre tabelas
        // Away embaixo
        if (allSetsData[setNum]?.away && teams?.away) {
          pdf.setFontSize(12);
          pdf.setFont("helvetica", "bold");
          pdf.text(awayTeam, margin, yOffset);
          yOffset += 10; // respiro
          yTableEnd = drawDetailedTable(
            pdf,
            allSetsData[setNum].away,
            teams.away,
            "", // não desenha nome do time dentro da tabela
            yOffset,
            teams.home?.length || 0,
            margin,
            pageHeight
          );
          yOffset = yTableEnd + 10;
        }
      }
      // 3. RELATÓRIO DE FUNDAMENTOS (4 por página: 2 em cima, 2 embaixo)
      const fundamentalsData = await fetchFundamentalsData();
      const fundamentosKeys = ["S", "R", "E", "A", "B", "D"];

      // Home team - 1 página (6 fundamentos por página)
      pdf.addPage();
      yOffset = addPageHeader(
        pdf,
        "Partida",
        "Relatório por Atleta - Fundamentos",
        homeTeam,
        awayTeam,
        null,
        margin,
        20
      );
      if (fundamentalsData.home?.athletes) {
        pdf.setFontSize(12);
        pdf.setFont("helvetica", "bold");
        pdf.text(homeTeam, margin, yOffset);
        yOffset += 10; // respiro
        yOffset += createFundamentalsQuadTable(
          pdf,
          fundamentalsData.home.athletes,
          "", // não desenha nome do time dentro da tabela
          fundamentosKeys,
          yOffset,
          margin,
          pageHeight
        );
      }

      // Away team - 1 página (6 fundamentos por página)
      pdf.addPage();
      yOffset = addPageHeader(
        pdf,
        "Partida",
        "Relatório por Atleta - Fundamentos",
        homeTeam,
        awayTeam,
        null,
        margin,
        20
      );
      if (fundamentalsData.away?.athletes) {
        pdf.setFontSize(12);
        pdf.setFont("helvetica", "bold");
        pdf.text(awayTeam, margin, yOffset);
        yOffset += 10; // respiro
        yOffset += createFundamentalsQuadTable(
          pdf,
          fundamentalsData.away.athletes,
          "", // não desenha nome do time dentro da tabela
          fundamentosKeys,
          yOffset,
          margin,
          pageHeight
        );
      }
      // Salvar o PDF
      const fileName = `scout_${homeTeam}_vs_${awayTeam}_${
        new Date().toISOString().split("T")[0]
      }.pdf`;
      addPageNumbers(pdf);
      pdf.save(fileName);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      alert("Erro ao gerar PDF. Tente novamente.");
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex justify-end mt-2 mb-4">
      <button
        onClick={exportToPDF}
        disabled={isExporting}
        className={`
          bg-gray-100 hover:bg-gray-200 disabled:bg-gray-50
          text-gray-700 font-medium py-2 px-3 rounded border border-gray-300
          transition-all duration-200 flex items-center gap-1 text-sm
          ${
            isExporting
              ? "cursor-not-allowed"
              : "cursor-pointer hover:border-gray-400"
          }
        `}
        title="Exportar relatórios para PDF"
      >
        {isExporting ? (
          <>
            <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24">
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            <span>Gerando...</span>
          </>
        ) : (
          <>
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <span>Exportar PDF</span>
          </>
        )}
      </button>
    </div>
  );
};

export default ExportPDFButton;
